import { defineMessages } from 'react-intl';

export default defineMessages({
  tableHeaderProduct: {
    id: 'features.walletFinancialPositions.tableHeaderProduct',
    defaultMessage: 'Prodotto',
    description: 'Label for the table column header "Prodotto"',
  },
  tableHeaderCode: {
    id: 'features.walletFinancialPositions.tableHeaderCode',
    defaultMessage: 'Codice',
    description: 'Label for the table column header "Codice"',
  },
  tableHeaderContract: {
    id: 'features.walletFinancialPositions.tableHeaderContract',
    defaultMessage: 'Contratto',
    description: 'Label for the table column header "Contratto"',
  },
  tableHeaderQuantity: {
    id: 'features.walletFinancialPositions.tableHeaderQuantity',
    defaultMessage: 'Quantità',
    description: 'Label for the table column header "Quantità"',
  },
  tableHeaderPaidToBeValidated: {
    id: 'features.walletFinancialPositions.tableHeaderPaidToBeValidated',
    defaultMessage: 'Versato non ancora avvalorato',
    description:
      'Label for the table column header "Versato non ancora avvalorato"',
  },
  tableHeaderPaidValidated: {
    id: 'features.walletFinancialPositions.tableHeaderPaidValidated',
    defaultMessage: 'Versato Avvalorato',
    description: 'Label for the table column header "Versato Avvalorato"',
  },
  tableCapitalEstimates: {
    id: 'features.walletFinancialPositions.tableCapitalEstimates',
    defaultMessage: 'Proventi/Rimborsi di capitale',
    description:
      'Label for the table column header "Proventi/Rimborsi di capitale"',
  },
  tableHeaderCurrency: {
    id: 'features.walletFinancialPositions.tableHeaderCurrency',
    defaultMessage: 'Divisa',
    description: 'Label for the table column header "Divisa"',
  },
  tableHeaderObligation: {
    id: 'features.walletFinancialPositions.tableHeaderObligation',
    defaultMessage: 'Impegni',
    description: 'Label for the table column header "Impegni"',
  },
  tableHeaderAveragePurchasePrice: {
    id: 'features.walletFinancialPositions.tableHeaderAveragePurchasePrice',
    defaultMessage: 'Prezzo medio di carico',
    description: 'Label for the table column header "Prezzo medio di carico"',
  },
  tableHeaderAveragePurchaseExchange: {
    id: 'features.walletFinancialPositions.tableHeaderAveragePurchaseExchange',
    defaultMessage: 'Carico medio cambio',
    description: 'Label for the table column header "Carico medio cambio"',
  },
  tableHeaderShareDividedValue: {
    id: 'features.walletFinancialPositions.tableHeaderShareDividedValue',
    defaultMessage: 'Valore quota divisa',
    description: 'Label for the table column header "Valore quota divisa"',
  },
  tableHeaderShareDividedQuoteValue: {
    id: 'features.walletFinancialPositions.tableHeaderShareDividedQuoteValue',
    defaultMessage: 'Valore attuali quota',
    description: 'Label for the table column header "Valore attuali quota"',
  },
  tableHeaderChange: {
    id: 'features.walletFinancialPositions.tableHeaderChange',
    defaultMessage: 'Cambio',
    description: 'Label for the table column header "Cambio"',
  },
  tableHeaderDate: {
    id: 'features.walletFinancialPositions.tableHeaderDate',
    defaultMessage: 'Data',
    description: 'Label for the table column header "Data"',
  },
  tableHeaderCounterValue: {
    id: 'features.walletFinancialPositions.tableHeaderCounterValue',
    defaultMessage: 'Controvalore',
    description: 'Label for the table column header "Controvalore"',
  },
  tableHeaderCounterValueShort: {
    id: 'features.walletFinancialPositions.tableHeaderCounterValueShort',
    defaultMessage: 'Controvalore (€)',
    description: 'Short label for the table column "Controvalore"',
  },
  tableHeaderGainEuros: {
    id: 'features.walletFinancialPositions.tableHeaderGainEuros',
    defaultMessage: 'Rendimento (€)',
    description: 'Label for the table column header "Rendimento (€)"',
  },
  tableHeaderGainPercentage: {
    id: 'features.walletFinancialPositions.tableHeaderGainPercentage',
    defaultMessage: 'Rendimento (%)',
    description: 'Label for the table column header "Rendimento (%)"',
  },
  tableHeaderCommitment: {
    id: 'features.walletFinancialPositions.tableHeaderCommitment',
    defaultMessage: 'Commitment',
    description: 'Label for the table column header "Commitment"',
  },
  tableHeaderVersato: {
    id: 'features.walletFinancialPositions.tableHeaderVersato',
    defaultMessage: 'Versato',
    description: 'Label for the table column header "Versato"',
  },
  footerTotalLabel: {
    id: 'features.walletFinancialPositions.footerTotalLabel',
    defaultMessage: 'Totale',
    description:
      'Label for the total amount in the footer of the macrocategory sections',
  },
  managedCategoryFooterDisclaimer: {
    id: 'features.walletFinancialPositions.managedCategoryFooterDisclaimer',
    defaultMessage: '*Il fondo è stato soggetto di funzione da parte della SGR',
    description:
      'Disclaimer for the macrocategory Managed shown if a product has the SGR flag',
  },
  mergedFundsFooterDisclaimer: {
    id: 'features.walletFinancialPositions.mergedFundsFooterDisclaimer',
    defaultMessage: '*Questo fondo è stato oggetto di fusione',
    description: 'Disclaimer for mergedFundsFooterDisclaimer',
  },
  welfareCategoryFooterDisclaimer: {
    id: 'features.walletFinancialPositions.welfareCategoryFooterDisclaimer',
    defaultMessage: '* Valori stimati',
    description:
      'Disclaimer for the macrocategory Welfare shown if a product has some items in transit',
  },
  welfareCategoryFooterExGarantitoDisclaimer: {
    id: 'features.walletFinancialPositions.welfareCategoryFooterExGarantitoDisclaimer',
    defaultMessage:
      '**Quote rinvenienti dalla Fusione del comparto ex garantito',
    description: 'Disclaimer for the ex Garantito Welfare',
  },
  tableHeaderTotalPremiumsPaid: {
    id: 'features.walletFinancialPositions.tableHeaderTotalPremiumsPaid',
    defaultMessage: 'Totale premi versati',
    description: 'Label for the table column header "Totale premi versati"',
  },
  tableHeaderTotalPremiumsPaidShort: {
    id: 'features.walletFinancialPositions.tableHeaderTotalPremiumsPaidShort',
    defaultMessage: 'Premi vers.',
    description: 'Label for the table column header "Premi vers."',
  },
  tableHeaderBalancePosition: {
    id: 'features.walletFinancialPositions.tableHeaderBalancePosition',
    defaultMessage: 'Saldo posizione',
    description: 'Label for the table column header "Saldo posizione"',
  },
  tableHeaderItemsInTransit: {
    id: 'features.walletFinancialPositions.tableHeaderItemsInTransit',
    defaultMessage: 'Partite viaggianti',
    description: 'Label for the table column header "Partite viaggianti"',
  },
  tableHeaderAccountBalance: {
    id: 'features.walletFinancialPositions.tableHeaderAccountBalance',
    defaultMessage: 'Saldo contabile',
    description: 'Label for the table column header "Saldo contabile"',
  },
  tableHeaderAccountBalanceDate: {
    id: 'features.walletFinancialPositions.tableHeaderAccountBalanceDate',
    defaultMessage: 'Data saldo contabile',
    description: 'Label for the table column header "Data saldo contabile"',
  },
  tableHeaderCashBalance: {
    id: 'features.walletFinancialPositions.tableHeaderCashBalance',
    defaultMessage: 'Saldo liquido',
    description: 'Label for the table column header "Saldo liquido"',
  },
  tableHeaderCashBalanceDate: {
    id: 'features.walletFinancialPositions.tableHeaderCashBalanceDate',
    defaultMessage: 'Data saldo liquido',
    description: 'Label for the table column header "Data saldo liquido"',
  },
  tableHeaderAvailableBalance: {
    id: 'features.walletFinancialPositions.tableHeaderAvailableBalance',
    defaultMessage: 'Saldo disponibile',
    description: 'Label for the table column header "Saldo disponibile"',
  },
  tableHeaderAvailableBalanceShort: {
    id: 'features.walletFinancialPositions.tableHeaderAvailableBalanceShort',
    defaultMessage: 'Saldo disp.',
    description: 'Label for the table column header "Saldo disp."',
  },
  tableHeaderAvailableBalanceDate: {
    id: 'features.walletFinancialPositions.tableHeaderAvailableBalanceDate',
    defaultMessage: 'Data saldo disponibile',
    description: 'Label for the table column header "Data saldo disponibile"',
  },
});
